var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewAudioFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4443 3.46896V3.02451C24.4443 1.6245 25.8444 0.624491 27.1333 1.13561C34.6666 4.0023 40 11.269 40 19.8024C40 28.3358 34.6666 35.6026 27.1333 38.4692C25.8444 38.9581 24.4443 37.9804 24.4443 36.5803V36.1359C24.4443 35.2914 24.9777 34.5581 25.7777 34.247C31.5111 31.9581 35.5555 26.3358 35.5555 19.8024C35.5555 13.269 31.5111 7.64677 25.7777 5.35786C24.9999 5.04675 24.4443 4.31341 24.4443 3.46896ZM0 15.358V24.2469C0 25.4692 1.00001 26.4692 2.22224 26.4692H8.88896L16.2001 33.7803C17.6001 35.1804 20.0002 34.1804 20.0002 32.2026V7.38014C20.0002 5.40234 17.6001 4.40233 16.2001 5.80234L8.88896 13.1357H2.22224C1.00001 13.1357 0 14.1357 0 15.358ZM29.9999 19.8024C29.9999 15.869 27.7333 12.4912 24.4443 10.8468V28.7358C27.7333 27.1136 29.9999 23.7358 29.9999 19.8024Z",
    fill: "#555893"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewAudioFeedback);
export default __webpack_public_path__ + "static/media/new_audio_feedback.6ccec2f4.svg";
export { ForwardRef as ReactComponent };